import React from 'react';
import { Outlet } from 'react-router-dom';

const PublicTemplate = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Outlet />
    </div>
  );
};

export default PublicTemplate; 